import { batch, computed, signal } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"


export const isLoadingUserSettingOfficesGroupData = signal(true)
export const userSettingOfficesGroupData = signal([])
export const userSettingsOfficesGroupFormData = signal({})

// Computed
export const isOpenUserSettingsOfficesGroupDrawer = computed(() => !isEmpty(userSettingsOfficesGroupFormData.value))
export const isEditUserSettingsOfficesGroupDrawer = computed(() => userSettingsOfficesGroupFormData.value?.id !== null)

// Functions
export const clearUserSettingOfficesGroupSignals = () => batch(() => {
	isLoadingUserSettingOfficesGroupData.value = true
	userSettingOfficesGroupData.value = []
	userSettingsOfficesGroupFormData.value = {}
})